import { IButtonProps, IconButton } from "@fluentui/react";
import React from "react";

export type TextFieldClearButtonProps = Pick<IButtonProps, "onClick" | "disabled" | "id"> & {
    testId?: string;
};

export const TextFieldClearButton: React.FunctionComponent<TextFieldClearButtonProps> = (
    props: TextFieldClearButtonProps
) => {
    const clearButtonBackgroudColor = "transparent";

    return (
        <IconButton
            iconProps={{ iconName: "Cancel" }}
            styles={{
                root: { height: 30, maxHeight: 30 },
                rootHovered: { background: clearButtonBackgroudColor },
                rootPressed: { background: clearButtonBackgroudColor },
                rootDisabled: { background: clearButtonBackgroudColor },
                icon: { fontSize: 12 }
            }}
            disabled={props.disabled}
            onClick={props.onClick}
            id={props.id}
            data-testid={props.testId}
        />
    );
};
